import React, { useState } from 'react';
import { useHistory } from 'react-router';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	makeStyles,
	Step,
	StepLabel,
	Stepper,
	SvgIcon,
	Typography,
} from '@material-ui/core';
import { ReactComponent as LampIcon } from 'src/assets/icons/lamp.svg';
import { ReactComponent as FlameIcon } from 'src/assets/icons/flame.svg';
import {
	ArrowForwardIos as ArrowForwardIosIcon,
	Check as CheckIcon,
	Close as CloseIcon,
	ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import layoutService from 'src/services/layoutService';
import Label from 'src/components/Label';
import moment from 'moment';
import { appMobileService } from 'src/services';

const useStyle = makeStyles(theme => ({
	
	root: {
		borderRadius: 4,
		marginBottom: theme.spacing(2),
		"&:before": {
			height: 0
		},
		'& .MuiCardHeader-avatar': {
			'align-self': 'flex-start'
		}
	},
	avatar: {
		color: theme.palette.text.primary
	},
	error: {
		color: theme.palette.error.main
	},
	success: {
		color: theme.palette.success.main
	},
	supply: {
		width: "100%"
	}
}));

function ExpiredSupply({ entity, loader, expanded = false }) {
	const classes = useStyle();
	const history = useHistory();
	const [isExpanded, setIsExpanded] = useState(expanded);
	
	function handleClick(entity) {
		if(appMobileService.isMobile() || layoutService.isMobile())
			history.push('/mobile/supply/invoices', { entity });
		else 
			history.push("/app/crm/invoices", entity.contract.id)
	}

	function stepIcon({ error }) {

		return (
			error ? 
				<CloseIcon className={classes.error} />
			:
				<CheckIcon className={classes.success} />
		)
	}

	return (
		<Accordion
			expanded={isExpanded}
			onChange={() => setIsExpanded(!isExpanded)}
			className={classes.root}
		>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Box display="flex">
					<Box mr={2}>
						<SvgIcon className={classes.avatar}>
							{entity?.counterElement === 'POD' ? <LampIcon /> : <FlameIcon />}
						</SvgIcon>
					</Box>

					<Box display="flex" alignItems="center">
						<Box>
							<Typography variant="h4">{entity?.code}</Typography>
							<Typography variant="body2" color="textSecondary">
								{entity?.address}
							</Typography>
						</Box>
					</Box>
				</Box>
			</AccordionSummary>
			<AccordionDetails>
				<Stepper orientation="vertical" className={classes.supply}>
					{entity?.contractLines?.map(x => (
						<Step key={x?.id} onClick={() => handleClick(x)}>
							<StepLabel error={x?.expired} StepIconComponent={stepIcon}>
								<Box display="flex" alignItems="center">
									<Box>
										<Label color={x?.expired ? 'error' : 'success'}>
											{x?.expired
												? `Cessato il ${moment(x?.expiredDate).format(
														'DD/MM/YYYY'
												  )}`
												: `Attivo dal ${moment(x?.startDate).format(
														'DD/MM/YYYY'
												  )}`}
										</Label>

										<Typography variant="subtitle2" color="textPrimary">
											{x?.contract?.no}
										</Typography>
									</Box>

									<Box flexGrow="1" />

									<SvgIcon fontSize="small" color="disabled">
										<ArrowForwardIosIcon />
									</SvgIcon>
								</Box>
							</StepLabel>
						</Step>
					))}
				</Stepper>
			</AccordionDetails>
		</Accordion>
	);
}

export default ExpiredSupply;
